import React, { useState } from 'react';
import { Play } from 'lucide-react';
import coverImage from '../assets/howitworks/cover_optional.png';

const bgClasses = {
  blue: { bg: "bg-[#4285F4]", text: "text-white" },
  red: { bg: "bg-[#EA4335]", text: "text-white" },
  green: { bg: "bg-[#34A853]", text: "text-white" }
};

const StepCard = ({ number, bgColor, title, description, delay = 0 }) => {
  const classes = bgClasses[bgColor] || bgClasses.blue;
  return (
    <div data-aos="fade-up" data-aos-delay={delay} className="text-center group animate-fadeInUp" style={{ animationDelay: `${delay}ms` }}>
      <div className={`${classes.bg} w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 transition-all duration-300 group-hover:scale-110 shadow-xl`}>
        <span className={`${classes.text} text-3xl font-bold`}>{number}</span>
      </div>
      <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">{title}</h3>
      <p className="text-gray-700 dark:text-gray-300">{description}</p>
    </div>
  );
};

const VideoDemo = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const playVideo = () => {
    setIsVideoPlaying(true);
  };

  return (
    <div className="max-w-4xl mx-auto glass-card rounded-3xl overflow-hidden shadow-2xl group relative z-10 animate-fadeInUp" id='how-it-works' style={{ animationDelay: '400ms' }}>
  <div className="relative w-full aspect-video">
    {!isVideoPlaying ? (
      <>
        <img
          src={coverImage}
          alt="Video Thumbnail"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div
          className="absolute inset-0 bg-black/40 flex items-center justify-center cursor-pointer hover:bg-black/30 transition-all duration-300 ripple-effect"
          onClick={playVideo}
        >
          <div className="bg-gradient-to-r from-[#4285F4] to-[#34A853] p-6 rounded-full transition-all duration-300 hover:scale-110 shadow-2xl">
            <Play className="text-white h-16 w-16 fill-current" />
          </div>
        </div>
      </>
    ) : (
      <iframe
        className="absolute inset-0 w-full h-full"
        src="https://www.youtube.com/embed/Do85QlO1UOU?si=i9jYVcBS2PCtgkLM&autoplay=1"
        style={{ border: "none" }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    )}
  </div>
</div>



  );
};

const HowItWorksSection = () => {
  const steps = [
    {
      number: 1,
      bgColor: "blue",
      title: "Upload Prompts",
      description: "Simply upload your list of prompts in CSV format or enter them directly.",
      delay: 0
    },
    {
      number: 2,
      bgColor: "red",
      title: "Customize Settings",
      description: "Choose your preferred AI tool and adjust parameters for optimal results.",
      delay: 100
    },
    {
      number: 3,
      bgColor: "green",
      title: "Generate & Download",
      description: "Start generation and download your results with automatic CSV export.",
      delay: 200
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white dark:bg-gray-900 relative overflow-hidden">
      {/* Google-themed ambient backgrounds */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl animate-pulse bg-[#4285F4]"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full blur-2xl animate-pulse bg-[#34A853]" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full blur-3xl animate-pulse bg-[#FBBC04]" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16 animate-fadeInUp">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
          <span className='text-[#4285F4]'>Get Started</span> in 3 Easy Steps
          </h2>
          <p className="text-lg text-gray-700 font-medium dark:text-gray-300 max-w-3xl mx-auto">
            Simple 3-step process to automate your content creation
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
  <StepCard key={`${step.number}-${index}`} {...step} />
))}

        </div>
        
        {/* Video Demo */}
        <VideoDemo />
      </div>
    </section>
  );
};

export default HowItWorksSection;
